import { useCallback } from 'react';

import useAuth from 'hooks/useAuth';
import { isAuthorizedForRoles } from 'utils/permission';

const usePermission = ({ isAdminNotAuthorized = false }) => {
    const { user } = useAuth();

    const can = useCallback(
        (action, resource) => {
            return isAuthorizedForRoles(user?.roles || [], action, resource, isAdminNotAuthorized);
        },
        [user?.roles, isAdminNotAuthorized]
    );

    return { can };
};

export default usePermission;
